var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-page" }, [
    _c("header", { staticClass: "auth-header" }, [
      _c("div", { staticClass: "header-content" }, [
        _vm._m(0),
        _vm._m(1),
        _c("span", { staticClass: "header-auth-text desktop-nav" }, [
          _vm._v("Log In or Sign Up")
        ]),
        _c(
          "button",
          {
            staticClass: "mobile-menu-btn",
            on: {
              click: function($event) {
                _vm.mobileMenuOpen = !_vm.mobileMenuOpen
              }
            }
          },
          [_c("span", { staticClass: "hamburger-icon" })]
        )
      ]),
      _vm.mobileMenuOpen
        ? _c("nav", { staticClass: "header-nav mobile-nav" }, [
            _c(
              "a",
              {
                attrs: { href: "https://tixlist.gobo.show", target: "_blank" }
              },
              [_vm._v("BUY TICKETS")]
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.gobo.show/?page_id=54",
                  target: "_blank"
                }
              },
              [_vm._v("WHY GOBO?")]
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.gobo.show/?page_id=55",
                  target: "_blank"
                }
              },
              [_vm._v("WHO WE'RE FOR")]
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.gobo.show/?page_id=56",
                  target: "_blank"
                }
              },
              [_vm._v("COMPARE")]
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.gobo.show/?page_id=57",
                  target: "_blank"
                }
              },
              [_vm._v("HOW IT WORKS")]
            ),
            _c(
              "a",
              {
                attrs: { href: "https://www.gobo.show/pro", target: "_blank" }
              },
              [_vm._v("GOBO PRO")]
            ),
            _c("span", { staticClass: "header-auth-text" }, [
              _vm._v("Log In or Sign Up")
            ])
          ])
        : _vm._e()
    ]),
    _vm._m(2),
    _c("div", { staticClass: "auth-content-wrapper" }, [
      _c("div", { staticClass: "angled-white-bg" }, [
        _c("main", { staticClass: "auth-main" }, [
          _c(
            "form",
            {
              staticClass: "auth-column",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.handleLoginSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c("h1", { staticClass: "section-title" }, [
                _vm._v("Login to your account")
              ]),
              _c("h4", { staticClass: "section-subtitle" }, [
                _vm._v("Create, view, or edit events.")
              ]),
              _c("div", { staticClass: "input-group" }, [
                _c("label", [_vm._v("Email")]),
                _c("div", { staticClass: "input-wrapper" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "input-icon",
                      attrs: { viewBox: "0 0 20 20", fill: "currentColor" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d:
                            "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                        }
                      })
                    ]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginEmail,
                        expression: "loginEmail"
                      }
                    ],
                    staticClass: "custom-input has-icon",
                    attrs: { type: "email", placeholder: "Email" },
                    domProps: { value: _vm.loginEmail },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) return
                          _vm.loginEmail = $event.target.value
                        },
                        function($event) {
                          _vm.loginError = ""
                        }
                      ]
                    }
                  })
                ]),
                _vm.loginError
                  ? _c("p", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(_vm.loginError))
                    ])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "input-group" }, [
                _c("label", [_vm._v("Password")]),
                _c("div", { staticClass: "input-wrapper" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "input-icon",
                      attrs: { viewBox: "0 0 20 20", fill: "currentColor" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d:
                            "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                          "clip-rule": "evenodd"
                        }
                      })
                    ]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginPassword,
                        expression: "loginPassword"
                      }
                    ],
                    staticClass: "custom-input has-icon",
                    attrs: { type: "password", placeholder: "Password" },
                    domProps: { value: _vm.loginPassword },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) return
                          _vm.loginPassword = $event.target.value
                        },
                        function($event) {
                          _vm.loginError = ""
                          _vm.loginPasswordError = ""
                        }
                      ]
                    }
                  })
                ]),
                _vm.loginPasswordError
                  ? _c("p", { staticClass: "error-text" }, [
                      _vm._v(" " + _vm._s(_vm.loginPasswordError) + " ")
                    ])
                  : _vm._e()
              ]),
              _c("a", { staticClass: "forgot-link", attrs: { href: "#" } }, [
                _vm._v("Forgot your password?")
              ]),
              _vm._m(3)
            ]
          ),
          _c("div", { staticClass: "divider" }),
          _c(
            "form",
            {
              staticClass: "auth-column",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.handleCreateAccountSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c("h1", { staticClass: "section-title" }, [
                _vm._v("Sign up and get started")
              ]),
              _c("h4", { staticClass: "section-subtitle" }, [
                _vm._v("It's easy and it's free.")
              ]),
              _c("div", { staticClass: "input-group" }, [
                _c("label", [_vm._v("Name")]),
                _c("div", { staticClass: "input-wrapper" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "input-icon",
                      attrs: { viewBox: "0 0 20 20", fill: "currentColor" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d:
                            "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                          "clip-rule": "evenodd"
                        }
                      })
                    ]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.createName,
                        expression: "createName"
                      }
                    ],
                    staticClass: "custom-input has-icon",
                    attrs: { type: "text", placeholder: "Name" },
                    domProps: { value: _vm.createName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.createName = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "input-group" }, [
                _c("label", [_vm._v("Email")]),
                _c("div", { staticClass: "input-wrapper" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "input-icon",
                      attrs: { viewBox: "0 0 20 20", fill: "currentColor" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d:
                            "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                        }
                      })
                    ]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.createEmail,
                        expression: "createEmail"
                      }
                    ],
                    staticClass: "custom-input has-icon",
                    attrs: { type: "email", placeholder: "Email" },
                    domProps: { value: _vm.createEmail },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.createEmail = $event.target.value
                      }
                    }
                  })
                ]),
                _vm.createAccountError
                  ? _c("p", { staticClass: "error-text" }, [
                      _vm._v(" " + _vm._s(_vm.createAccountError) + " ")
                    ])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "input-group" }, [
                _c("label", [_vm._v("Password")]),
                _c("div", { staticClass: "input-wrapper" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "input-icon",
                      attrs: { viewBox: "0 0 20 20", fill: "currentColor" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d:
                            "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                          "clip-rule": "evenodd"
                        }
                      })
                    ]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.createPassword,
                        expression: "createPassword"
                      }
                    ],
                    staticClass: "custom-input has-icon",
                    attrs: { type: "password", placeholder: "Password" },
                    domProps: { value: _vm.createPassword },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) return
                          _vm.createPassword = $event.target.value
                        },
                        _vm.validatePassword
                      ]
                    }
                  })
                ]),
                _vm.createPasswordError
                  ? _c("div", { staticClass: "password-rules" }, [
                      _c(
                        "p",
                        {
                          class: _vm.passwordValidation.capital
                            ? "valid"
                            : "invalid"
                        },
                        [_vm._v(" At least one uppercase letter ")]
                      ),
                      _c(
                        "p",
                        {
                          class: _vm.passwordValidation.digit
                            ? "valid"
                            : "invalid"
                        },
                        [_vm._v(" At least one digit ")]
                      ),
                      _c(
                        "p",
                        {
                          class: _vm.passwordValidation.length
                            ? "valid"
                            : "invalid"
                        },
                        [_vm._v(" Be longer than 6 characters ")]
                      )
                    ])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "input-group" }, [
                _c("div", { staticClass: "input-wrapper" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "input-icon",
                      attrs: { viewBox: "0 0 20 20", fill: "currentColor" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d:
                            "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                          "clip-rule": "evenodd"
                        }
                      })
                    ]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.createConfirmPassword,
                        expression: "createConfirmPassword"
                      }
                    ],
                    staticClass: "custom-input has-icon",
                    attrs: {
                      type: "password",
                      placeholder: "Confirm Password"
                    },
                    domProps: { value: _vm.createConfirmPassword },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.createConfirmPassword = $event.target.value
                      }
                    }
                  })
                ]),
                _vm.confirmPasswordError
                  ? _c("p", { staticClass: "error-text" }, [
                      _vm._v(" " + _vm._s(_vm.confirmPasswordError) + " ")
                    ])
                  : _vm._e()
              ]),
              _vm._m(4),
              _vm._m(5)
            ]
          )
        ])
      ])
    ]),
    _vm._m(6)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "logo-link", attrs: { href: "https://www.gobo.show" } },
      [
        _c("img", {
          staticClass: "logo",
          attrs: { src: "/img/gobo-logo-white.svg", alt: "Gobo" }
        })
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("nav", { staticClass: "header-nav desktop-nav" }, [
      _c(
        "a",
        { attrs: { href: "https://tixlist.gobo.show", target: "_blank" } },
        [_vm._v("BUY TICKETS")]
      ),
      _c(
        "a",
        {
          attrs: { href: "https://www.gobo.show/?page_id=54", target: "_blank" }
        },
        [_vm._v("WHY GOBO?")]
      ),
      _c(
        "a",
        {
          attrs: { href: "https://www.gobo.show/?page_id=55", target: "_blank" }
        },
        [_vm._v("WHO WE'RE FOR")]
      ),
      _c(
        "a",
        {
          attrs: { href: "https://www.gobo.show/?page_id=56", target: "_blank" }
        },
        [_vm._v("COMPARE")]
      ),
      _c(
        "a",
        {
          attrs: { href: "https://www.gobo.show/?page_id=57", target: "_blank" }
        },
        [_vm._v("HOW IT WORKS")]
      ),
      _c(
        "a",
        { attrs: { href: "https://www.gobo.show/pro", target: "_blank" } },
        [_vm._v("GOBO PRO")]
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-hero" }, [
      _c("h1", { staticClass: "auth-hero-title" }, [
        _vm._v("Log In or Sign Up")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "button-container" }, [
      _c("button", { staticClass: "primary-btn", attrs: { type: "submit" } }, [
        _vm._v("Sign In")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", { staticClass: "terms-text" }, [
      _vm._v(" By signing up, you agree to our "),
      _c(
        "a",
        {
          attrs: { href: "https://newsite.gobo.show/terms/", target: "_blank" }
        },
        [_vm._v("Terms of Service")]
      ),
      _vm._v(
        ". Gobo takes a 5% commission on tickets sold, inclusive of credit card fees. "
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "button-container" }, [
      _c("button", { staticClass: "primary-btn", attrs: { type: "submit" } }, [
        _vm._v("Create Account")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "auth-footer" }, [
      _c("div", { staticClass: "footer-content" }, [
        _c("div", { staticClass: "footer-column" }, [
          _c("h4", [_vm._v("Gobo")]),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.gobo.show/about-us/",
                target: "_blank"
              }
            },
            [_vm._v("About Us")]
          ),
          _c(
            "a",
            {
              attrs: { href: "https://www.gobo.show/blog/", target: "_blank" }
            },
            [_vm._v("Blog")]
          ),
          _c(
            "a",
            {
              attrs: { href: "https://www.gobo.show/media/", target: "_blank" }
            },
            [_vm._v("Media")]
          )
        ]),
        _c("div", { staticClass: "footer-column" }, [
          _c("h4", [_vm._v("Support Center")]),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.gobo.show/faq-general-ticket-questions/",
                target: "_blank"
              }
            },
            [_vm._v("General Questions")]
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.gobo.show/faq-ticket-buyers/",
                target: "_blank"
              }
            },
            [_vm._v("Ticket Buyer FAQs")]
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.gobo.show/faq-ticket-sellers/",
                target: "_blank"
              }
            },
            [_vm._v("Ticket Seller FAQs")]
          )
        ]),
        _c("div", { staticClass: "footer-column" }, [
          _c("h4", [_vm._v("General")]),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.gobo.show/privacy-policy/",
                target: "_blank"
              }
            },
            [_vm._v("Privacy Notice")]
          ),
          _c(
            "a",
            {
              attrs: { href: "https://www.gobo.show/terms/", target: "_blank" }
            },
            [_vm._v("Terms of Service")]
          )
        ])
      ]),
      _c("div", { staticClass: "footer-bottom" }, [
        _c("p", { staticClass: "copyright" }, [
          _vm._v("© 2026 Gobo Show, Inc.")
        ]),
        _c("div", { staticClass: "social-links" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.facebook.com/Goboshow",
                target: "_blank",
                "aria-label": "Facebook"
              }
            },
            [
              _c("img", {
                attrs: { src: "/img/icons/Facebook.svg", alt: "Facebook" }
              })
            ]
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.instagram.com/goboshow",
                target: "_blank",
                "aria-label": "Instagram"
              }
            },
            [
              _c("img", {
                attrs: { src: "/img/icons/Instagram.svg", alt: "Instagram" }
              })
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }